import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this.m12_1 = this;
        this.n12_1 = this;
        this.o12_1 = false;
      }
      p12(node, permissionsBitmask) {
        var prev = this.n12_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.o1m_1 & permissionsBitmask) === 0 && prev.p12(node, permissionsBitmask));
        } else {
          node.m12_1 = this;
          node.n12_1 = prev;
          prev.m12_1 = node;
          this.n12_1 = node;
          tmp = true;
        }
        return tmp;
      }
      e15(forbiddenElementsBit) {
        this.p12(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      q12() {
        if (this.o12_1)
          return false;
        var prev = this.n12_1;
        var next = this.m12_1;
        prev.m12_1 = next;
        next.n12_1 = prev;
        this.o12_1 = true;
        return true;
      }
      r12(node) {
        if (!(this.m12_1 === this))
          return false;
        this.p12(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.o1m_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
